import React from "react";

import { useTranslation } from "react-i18next";

import { LinkContext } from "../LinkProvider";
import { useContext } from "react";
import AnimatedCTA from "./AnimatedCTA";

function Button({ className }) {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <div className={className}>
      <AnimatedCTA href={link}>{t("common.cta")}</AnimatedCTA>
    </div>
  );
}

export default Button;
